var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loginLayout',[_c('UserAuthForm',{attrs:{"submitForm":_vm.loginUser,"buttonText":"Acceder","hasLogin":"true","hasPass":"true","hasAuth":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }